// gives the most clear string possible about any object
// useful to detect weird types of spaces
export function repr (value) {
  return JSON.stringify(value).replace(/[\u007F-\uFFFF]/g, chr => {
    return '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).substr(-4)
  })
}

// python style replacement, to ease copy-pasting regex
// uses both %s format and {0} format
export function format (str, ...args) {
  let count = 0
  return str.replace(/\{(\d+)\}|%s/g, (_, index) => {
    return index ? args[index] : args[count++]
  })
}

// see https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
export function hsv2rgb (h, s, v) {
  let h_i = parseInt(h * 6)
  let f = h * 6 - h_i
  let p = v * (1 - s)
  let q = v * (1 - f * s)
  let t = v * (1 - (1 - f) * s)
  let rgb
  switch (h_i) {
  case 0:
    rgb = [v, t, p]
    break
  case 1:
    rgb = [q, v, p]
    break
  case 2:
    rgb = [p, v, t]
    break
  case 3:
    rgb = [p, q, v]
    break
  case 4:
    rgb = [t, p, v]
    break
  case 5:
    rgb = [v, p, q]
    break
  }
  return 'rgb(' + rgb.map(x => parseInt(256 * x).toString()).join(',') + ')'
}

const golden_ratio_conjugate = 0.618033988749895
export function int2color (index, s, v) {
  if (s === undefined) s = 0.2
  if (v === undefined) v = 0.95
  let h = (index * golden_ratio_conjugate) % 1
  return hsv2rgb(h, s, v)
}

// because of vuejs runtime compilation dark magic,
// Promise extension is broken
export class StreamingPromise { // extends Promise {
  constructor (callback) {
    let out = {}
    // because of vuejs runtime compilation dark magic,
    // Promise extension is broken
    // super((resolve, reject) => {
    this._promise = new Promise((resolve, reject) => {
      out.resolve = resolve
      out.reject = reject
    })
    this._resolve = out.resolve
    this._reject = out.reject
    this.resolve = StreamingPromise.prototype.__resolve.bind(this)
    this.reject = StreamingPromise.prototype.__reject.bind(this)
    this._queue = [] // the queue of promises
    this._waiting = null // the resolve function of the promise
    if (typeof callback === 'function') {
      callback(this.resolve, this.reject)
    }
  }

  __resolve () {
    if (!this._resolve) return false
    let value = { done: true }
    this._resolve(value)
    this._resolve = null
    this._reject = null
    // waiting for data, but no more data to come
    if (this._waiting) {
      this._waiting.resolve(value)
      this._queue.shift()
      this._waiting = null
    }
    return true
  }

  __reject (...error) {
    if (!this._resolve) return false
    this._reject(...error)
    this._resolve = null
    this._reject = null
    // waiting for data, but no more data to come
    if (this._waiting) {
      this._waiting.reject(...error)
      this._queue.shift()
      this._waiting = null
    }
    return true
  }

  push (value) {
    if (!this._resolve) return false
    value = { value: value, done: false }
    // waiting for data, here it comes
    if (this._waiting) {
      this._waiting.resolve(value)
      this._queue.shift()
      this._waiting = null
    // queue a new promise
    } else {
      this._queue.push(Promise.resolve(value))
    }
  }

  read () {
    // already have a waiting promise
    if (this._waiting) {
      return this._queue[0]
    // send the next promise
    } else if (this._queue.length) {
      return this._queue.shift()
    // not resolved yet, wait for more
    } else if (this._resolve) {
      this._queue.push(new Promise((resolve, reject) => {
        this._waiting = { resolve, reject }
      }))
      return this._queue[0]
    // no more data
    } else {
      // because of vuejs runtime compilation dark magic,
      // Promise extension is broken
      // return this
      return this._promise
    }
  }

  // because of vuejs runtime compilation dark magic,
  // Promise extension is broken
  then (...args) { return this._promise.then(...args) }
  catch (...args) { return this._promise.catch(...args) }
  finally (...args) { return this._promise.finally(...args) }
}
